<template>
  <div :class="!userInfo ? 'login' : ''">
    <Loading :show="true" v-if="userInfo" />
    <div class="login-layout" v-else>
      <div class="login-left" v-if="leftArea">
        <div class="login-title">
          <div class="login-title1">Remote Feature Cloud</div>
          <div class="login-title2">MBE Power Management</div>
<!--          <div class="login-title3">-->
<!--             -->
<!--          </div>-->
        </div>
      </div>
      <div class="login-right">
        <!-- 语言选择：目前只保留英文(默认即为英文) -->
        <a-form-item class="login-language-wrapper" v-if="showLanguage">
          <a-select
            :getPopupContainer="triggerNode => triggerNode.parentNode"
            :default-value="currentLocale"
            class="login-language"
            @change="changeLanguage"
            style="width: 100%;"
            size="small"
          >
            <a-select-option value="zh-CN">简体中文</a-select-option>
            <a-select-option value="en-US"> English</a-select-option>
          </a-select>
        </a-form-item>

        <div class="login-container" :style="containerStyle">
          <!-- 自定义内容 -->
          <slot></slot>
        </div>

        <!-- copyright -->
        <div class="login-copyright">
          {{ $t('login_copyright') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { setCookie } from '@/libs/cookie';
import { mapGetters } from 'vuex';

export default {
  props: {
    leftArea: {
      type: Boolean,
      default: true,
    },
    containerStyle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentLanguage: 'en-US',
      showLanguage: false,
    };
  },

  computed: {
    ...mapGetters(['currentLocale', 'userInfo']),
  },

  created() {
    // 环境变量VUE_APP_LANGUAGE_SWITCH控制语言切换按钮的显示
    this.showLanguage = process.env.VUE_APP_LANGUAGE_SWITCH === 'true';
  },

  methods: {
    // 切换语言
    changeLanguage(val) {
      // 记录用于提交
      this.currentLanguage = val;

      // 设置cookie，用于刷新时，保持当前语言
      setCookie('locale', val);

      // 改变静态语言
      this.$i18n.locale = val;

      // 改变UI组件的语言
      this.$store.commit('setUiCurrentLocale', val);

      // 重新reload页面->改变页面title的语言
      window.location.reload();
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  width: 100%;
  height: 100vh;
  background: #1838d9;
  min-width: 1200px;

  .login-language-wrapper {
    position: absolute;
    top: 60px;
    right: 60px;
    z-index: 100;

    /deep/ .login-language {
      .ant-select-selection {
        box-shadow: none !important;
        border: #eee solid 1px !important;
        color: #999;
        height: 32px;
        line-height: 32px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .ant-select-arrow-icon {
        color: #999;
        font-size: 12px;
      }
    }
  }

  .login-layout {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    background: url('~@/assets/img/login/right.png') bottom center no-repeat;
    background-size: 100% 45%;

    .login-left {
      flex: 1;
      background: url('~@/assets/img/login/left.png') no-repeat center right;
      background-size: cover;
      width: 50%;
      height: 100%;
      border-radius: 0 80px 0 0;
      overflow: hidden;

      .login-title {
        margin: 70px 0 0 40px;
        .login-title1 {
          font-size: 70px;
          color: #fff;
          font-weight: 500;
          height: 100px;
        }

        .login-title2 {
          font-size: 70px;
          color: #fff;
          margin-bottom: 10px;
          font-weight: 900;
          line-height: 80px;
        }

        .login-title3 {
          font-size: 17px;
          color: #fff;
          margin-bottom: 10px;
          font-weight: 500;
          text-transform: uppercase;
        }
      }
    }
    .login-right {
      display: flex;
      flex: 1;
      background: linear-gradient(180deg, #1838d9 58.47%, rgba(24, 56, 217, 0.05) 109.07%);
      width: 50%;
      height: 100%;
      position: relative;
      align-items: center;

      .login-right-bg {
        width: 100%;
        background: url('~@/assets/img/login/right.png') lightgray 50% / cover no-repeat;
        height: 35%;
        position: absolute;
        bottom: 0;
      }

      .login-container {
        background: #fff;
        display: flex;
        justify-content: center;
        box-shadow: 0px 0px 50px rgba(118, 118, 118, 0.12);
        border-radius: 20px;
        max-width: 800px;
        margin: 0 auto;
      }
    }
  }

  .login-copyright {
    position: absolute;
    bottom: 20px;
    width: 100%;
    text-align: center;
    color: #fff;
    font-size: 14px;
  }
}

@media screen and (max-width: 760px) {
  .login {
    .login-layout {
      .login-left {
        display: none;
      }
    }
  }
}
</style>
